import React, { useContext, useEffect, useMemo, useState } from "react";
import queryString from "query-string";
import { emitLinkingModalAction, emitLinkingModalImpression, } from "@catchoftheday/analytics";
import { CustomerContext } from "@catchoftheday/customer";
import { legacyEventBus, useEventBus } from "@catchoftheday/state";
import { ONEPASS_LINK_QUERY_PARAM_KEY } from "../../../consts";
import { generateOnePassLinkingUrl, TRIGGER_ONEPASS_LINKING_MODAL_EVENT, } from "../../../utilities";
import { LinkingModal } from "../../pure/LinkingModal";
export const LinkingModalContainer = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [originalUrl, setOriginalUrl] = useState("");
    const [originalQueryParams, setOriginalQueryParams] = useState({});
    const { data: customer, loading } = useContext(CustomerContext);
    const { membership } = customer || {};
    const isLinked = useMemo(() => !!membership?.linked, [membership?.linked]);
    const analyticsAction = useMemo(() => customer?.id
        ? isLinked
            ? "Linking Exist Modal"
            : "Linking Modal"
        : null, [isLinked, customer?.id]);
    const closeModal = () => {
        if (analyticsAction) {
            emitLinkingModalAction({
                action: analyticsAction,
                label: "cancel",
            });
        }
        setIsOpen(false);
    };
    const eventHandler = (payload) => {
        if (typeof window !== "undefined") {
            const url = new URL(payload.originalUrl, window.location.origin);
            setOriginalUrl(url.pathname);
            if (url.search.length > 0) {
                setOriginalQueryParams(queryString.parse(url.search));
            }
            setIsOpen(true);
        }
    };
    useEventBus(TRIGGER_ONEPASS_LINKING_MODAL_EVENT, (event) => {
        if (event.payload) {
            eventHandler(event.payload);
        }
    });
    useEffect(() => {
        if (typeof window !== "undefined") {
            const queryParams = queryString.parse(window?.location?.search);
            if (queryParams?.[ONEPASS_LINK_QUERY_PARAM_KEY] === "1") {
                delete queryParams?.[ONEPASS_LINK_QUERY_PARAM_KEY];
                setOriginalQueryParams(queryParams);
                setOriginalUrl(window?.location?.pathname);
                setIsOpen(true);
            }
        }
        legacyEventBus?.on(TRIGGER_ONEPASS_LINKING_MODAL_EVENT.type, eventHandler);
        return () => {
            legacyEventBus?.detach(TRIGGER_ONEPASS_LINKING_MODAL_EVENT.type, eventHandler);
        };
    }, []);
    useEffect(() => {
        if (isOpen && analyticsAction) {
            emitLinkingModalImpression(analyticsAction);
        }
    }, [isOpen, analyticsAction]);
    const ctaUrl = generateOnePassLinkingUrl(originalUrl, originalQueryParams);
    return (<LinkingModal isOpen={isOpen} loading={loading} isLinked={isLinked} onClose={closeModal} email={customer?.email} ctaUrl={ctaUrl} onProceed={() => {
            if (analyticsAction) {
                emitLinkingModalAction({
                    action: analyticsAction,
                    label: "proceed",
                });
            }
        }}/>);
};
